import { render, staticRenderFns } from "./ThePersonalSupport.vue?vue&type=template&id=21331c64&"
import script from "./ThePersonalSupport.vue?vue&type=script&lang=js&"
export * from "./ThePersonalSupport.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalSupport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports